import { useTranslations } from 'next-intl';
import { Button } from '../../../../components/design-system';
import { Grape, Ticket } from '../../../../components/icons';
import Star from '../../../../components/icons/Star';
import { Link } from '../../../../navigation';

export default function SectionShop() {
  const t = useTranslations('loyalty');

  return (
    <div className="tw-mb-16 tw-max-w-5xl tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-px-4">
      <h3 className="tw-text-4xl tw-font-bold tw-text-greyscale-title tw-tracking-tighter tw-m-0 tw-p-0">
        {t('wallet.purchase.title')}
      </h3>
      <p className="tw-text-base tw-font-medium tw-tracking-tight tw-text-greyscale-body tw-text-center tw-m-0 tw-p-0">
        {t('wallet.purchase.description')}
      </p>
      <div className="tw-w-full tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-8 tw-pt-2">
        <div className="tw-bg-greyscale-offwhite tw-border tw-border-greyscale-separator tw-rounded-2xl tw-px-2 tw-py-4 tw-flex tw-flex-col tw-items-center tw-gap-4">
          <Ticket className="tw-w-12 tw-h-12 tw-stroke-1 tw-text-primary" />
          <div className="tw-text-center tw-space-y-0.5">
            <h6 className="tw-text-xl tw-font-bold tw-tracking-tighter tw-text-greyscale-body tw-m-0">
              {t('wallet.purchase.sections.0.title')}
            </h6>
            <p className="tw-text-base tw-font-medium tw-tracking-tight tw-text-greyscale-label">
              {t('wallet.purchase.sections.0.description')}
            </p>
          </div>
        </div>
        <div className="tw-bg-greyscale-offwhite tw-border tw-border-greyscale-separator tw-rounded-2xl tw-px-2 tw-py-4 tw-flex tw-flex-col tw-items-center tw-gap-4">
          <Star className="tw-w-12 tw-h-12 tw-stroke-1 tw-text-primary" />
          <div className="tw-text-center tw-space-y-0.5">
            <h6 className="tw-text-xl tw-font-bold tw-tracking-tighter tw-text-greyscale-body tw-m-0">
              {t('wallet.purchase.sections.1.title')}
            </h6>
            <p className="tw-text-base tw-font-medium tw-tracking-tight tw-text-greyscale-label">
              {t('wallet.purchase.sections.1.description')}
            </p>
          </div>
        </div>
        <div className="tw-bg-greyscale-offwhite tw-border tw-border-greyscale-separator tw-rounded-2xl tw-px-2 tw-py-4 tw-flex tw-flex-col tw-items-center tw-gap-4">
          <Grape className="tw-w-12 tw-h-12 tw-stroke-1 tw-text-primary" />
          <div className="tw-text-center tw-space-y-0.5">
            <h6 className="tw-text-xl tw-font-bold tw-tracking-tighter tw-text-greyscale-body tw-m-0">
              {t('wallet.purchase.sections.2.title')}
            </h6>
            <p className="tw-text-base tw-font-medium tw-tracking-tight tw-text-greyscale-label">
              {t('wallet.purchase.sections.2.description')}
            </p>
          </div>
        </div>
      </div>
      <div className="tw-text-center">
        <Link href={'/wallet/shop'}>
          <Button size="lg" className="tw-w-60">
            {t('wallet.purchase.button')}
          </Button>
        </Link>
      </div>
    </div>
  );
}
